/**
 * WPS Dental Theme - Main JavaScript
 *
 * @package WPS_Dental_Theme
 */

class WPSDentalTheme {
  constructor() {
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.onReady());
    } else {
      this.onReady();
    }
  }


  onReady() {
    this.initDynamicLoader();
    this.initAOS();
    this.initStickyHeader();
    this.fullScreenMenu();
    this.scrollSwiper();
    this.stickyNavNones();
    this.heroAnim();
    this.initSmileGallery();
    this.initbeforeAfterSlider();
    this.initVideoPopup();
    this.initPatientGallery();
    this.DynamicTestimonialAos();
    // this.initSplitText();
    this.officeSlider();
    this.fixConsultationCtas();
  }

  initAOS() {
    if (typeof AOS !== 'undefined') {
      AOS.init({
        duration: 800,
        easing: 'ease-in-out-sine',
        once: true,
        offset: 100,
        delay: 0,
      });
    }
  }

  // initSplitText() {
  //   if (typeof gsap === 'undefined') return;
    
  //   const elements = document.querySelectorAll('.js-split-text');
  //   if (!elements.length) return;

  //   if (typeof ScrollTrigger !== 'undefined') {
  //     gsap.registerPlugin(ScrollTrigger);
  //   }

  //   elements.forEach(el => {
  //     gsap.set(el, { autoAlpha: 1 });
      
  //     let words = [];
  //     let chars = [];
  //     let lines = [];

  //     if (typeof SplitText !== 'undefined') {
  //       const split = new SplitText(el, { type: "lines,words,chars" });
  //       words = split.words;
  //       chars = split.chars;
  //       lines = split.lines;
  //     } else if (typeof SplitType !== 'undefined') {
  //       const split = new SplitType(el, { types: 'lines,words, chars' });
  //       words = split.words;
  //       chars = split.chars;
  //       lines = split.lines;
  //     }

  //     if (lines && lines.length) {
  //       gsap.from(lines, {
  //         y: 100,
  //         opacity: 0,
  //         stagger: 0.4,
  //         duration: 0.6,
  //         ease: 'power3.out',
  //         scrollTrigger: {
  //           trigger: el,
  //           start: 'top 85%'
  //         }
  //       });
  //     }
  //   });
  // }

  initDynamicLoader(){
const loader = document.getElementById("loader");
if (!loader) return; 
const content = document.getElementById("content");
const percent = document.getElementById("percent");

let progress = 0;

function updateLoader() {

    progress += Math.random() * 12;

    if (progress > 100) {
        progress = 100;
    }

    percent.innerText = Math.floor(progress);

    if (progress < 100) {

        requestAnimationFrame(updateLoader);

    } else {

        setTimeout(() => {

            loader.style.opacity = "0";

            setTimeout(() => {

                loader.style.display = "none";
                content.classList.add("show");

            }, 1000);

        }, 300);

    }
}

    updateLoader();
  }



  initStickyHeader() {
    const stickyNav = document.querySelector(".sticky-navbar__wrapper");
    if (!stickyNav) return;

    jQuery(window).scroll(function () {
      if (jQuery(this).scrollTop() > 180) {
        jQuery(stickyNav).addClass("sticky");
      } else {
        jQuery(stickyNav).removeClass("sticky");
      }
    });
  }

  heroAnim() {
    if (typeof gsap === 'undefined') {
      return;
    }

    const navbar = document.querySelector(".wps-header-navbar__wrapper");
    const hero = document.querySelector(".wps-home-header-hero__wrapper");

    if (navbar) {
      const nav = navbar.querySelector(".wps-header-navbar__container");
      if (nav) {
        gsap.to(nav, {
          autoAlpha: 1,
          duration: 0.3,
        });
      }
    }

    if (hero) {
      const heading = hero.querySelector(".heading");
      const headerImage = hero.querySelector(".wps-header-image__container img");

      if (heading) {
        gsap.to(heading, {
          autoAlpha: 1,
          y: 0,
          duration: 0.3,
          delay: 0.1,
        });
      }

      const scrollTriggerLoaded = typeof ScrollTrigger !== 'undefined';
      if ( scrollTriggerLoaded ) {
        gsap.registerPlugin( ScrollTrigger );
      }

      if (headerImage) {
        const animationConfig = {
          y: 0,
          autoAlpha: 1,
          scale: 1,
          duration: 1.2,
          ease: 'power3.out',
        };

        if ( scrollTriggerLoaded ) {
          const triggerElement = hero.querySelector('.wps-header-image__container') || headerImage;
          animationConfig.scrollTrigger = {
            trigger: triggerElement,
            start: 'top 90%',
            end: 'top 60%',
            scrub: true,
          };
        }

        gsap.fromTo(
          headerImage,
          {
            y: 60,
            autoAlpha: 0,
            scale: 0.98,
          },
          animationConfig
        );
      }
    }
  }

  scrollSwiper() {
    const swiperElement = document.querySelector(".testimonials__container");
    new Swiper(swiperElement, {
       speed: 800,
      slidesPerView: 1,
      spaceBetween: 80,
      loop: true,
      lazyLoading: true,
      preventClicks: false,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
      effect: 'slide',
      breakpoints: {
        1100: {
          slidesPerView: 3,
        },
        760: {
          slidesPerView: 2,
        },
      },
    });
  }

  officeSlider() {
    const swiperElement = document.querySelector(".outside-the-office__container");
    new Swiper(swiperElement, {
       speed: 800,
      slidesPerView: 2,
      spaceBetween: 40,
      loop: true,
      lazyLoading: true,
      preventClicks: false,
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false,
        //   pauseOnMouseEnter: true,
        // },
        pagination: {
          el: '.outside-the-office__pagination',
          clickable: true,
        },

      effect: 'slide',
      breakpoints: {
        1100: {
          slidesPerView: 3,
        },
      },
    });
  }


  DynamicTestimonialAos() {
    document.querySelectorAll(".wps-homepage-testimonial-slider__wrapper .testimonial-item").forEach((card,index)=>{
    card.dataset.aosDelay = index * 200;
  });

  }

  fixConsultationCtas() {
    const bookingUrl =
      "https://edgebooking.ortho2.com/search?catalog=1cc54e47-f35e-46f7-a4b7-22f19aa4eb0a&code=opkgqe";

    document.querySelectorAll('a[href="#"], a[href=""]').forEach((link) => {
      const text = (link.textContent || "").replace(/\s+/g, " ").trim();

      if (!/consult|book\s*now/i.test(text)) {
        return;
      }

      link.setAttribute("href", bookingUrl);
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
    });
  }

  stickyNavNones() {
    const stickyNavNones = document.querySelectorAll(
      ".sticky-navbar__wrapper #main-menu a[href='#']"
    );

    stickyNavNones.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
      });
    });
  }

  initbeforeAfterSlider() {
    const galleries = document.querySelectorAll("[data-before-and-after]");
    if (!galleries.length) return;

    const updateComparison = (range) => {
      const slider = range.closest("[data-before-after-slider]");
      if (!slider) return;

      slider.style.setProperty("--before-and-after-position", `${range.value}%`);
    };

    const activateSlide = (gallery, index) => {
      const slides = gallery.querySelectorAll("[data-before-and-after-slide]");


      slides.forEach((slide) => {
        const isActive = slide.getAttribute("data-before-and-after-slide") === String(index);

        if (isActive) {
          const range = slide.querySelector("[data-before-after-range]");
          if (range) {
            updateComparison(range);
          }

          slide.classList.remove("is-entering");
          void slide.offsetWidth;
          slide.classList.add("is-entering");
        }
      });
    };

    galleries.forEach((gallery) => {
      gallery.querySelectorAll("[data-before-after-range]").forEach((range) => {
        updateComparison(range);

        range.addEventListener("input", () => {
          updateComparison(range);
        });
      });
    });

    
  } 

  initSmileGallery() {
    const galleries = document.querySelectorAll("[data-smile-gallery]");
    if (!galleries.length) return;

    const updateComparison = (range) => {
      const slider = range.closest("[data-before-after-slider]");
      if (!slider) return;

      slider.style.setProperty("--smile-gallery-position", `${range.value}%`);
    };

    const activateSlide = (gallery, index) => {
      const tabs = gallery.querySelectorAll("[data-smile-gallery-tab]");
      const slides = gallery.querySelectorAll("[data-smile-gallery-slide]");

      tabs.forEach((tab) => {
        const isActive = tab.getAttribute("data-smile-gallery-tab") === String(index);
        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
      });

      slides.forEach((slide) => {
        const isActive = slide.getAttribute("data-smile-gallery-slide") === String(index);

        slide.classList.toggle("is-active", isActive);
        slide.hidden = !isActive;

        if (isActive) {
          const range = slide.querySelector("[data-before-after-range]");
          if (range) {
            updateComparison(range);
          }

          slide.classList.remove("is-entering");
          void slide.offsetWidth;
          slide.classList.add("is-entering");
        }
      });
    };

    galleries.forEach((gallery) => {
      gallery.querySelectorAll("[data-before-after-range]").forEach((range) => {
        updateComparison(range);

        range.addEventListener("input", () => {
          updateComparison(range);
        });
      });

      const firstTab = gallery.querySelector("[data-smile-gallery-tab]");
      if (firstTab) {
        activateSlide(gallery, firstTab.getAttribute("data-smile-gallery-tab"));
      }

      gallery.addEventListener("click", (event) => {
        const tab = event.target.closest("[data-smile-gallery-tab]");
        if (!tab || !gallery.contains(tab)) return;

        event.preventDefault();
        activateSlide(gallery, tab.getAttribute("data-smile-gallery-tab"));
      });

      gallery.addEventListener("animationend", (event) => {
        const slide = event.target.closest("[data-smile-gallery-slide]");
        if (slide) {
          slide.classList.remove("is-entering");
        }
      });
    });
  }

  initVideoPopup() {
    jQuery(document).ready(function($){

      $(document).on('click', '.video-popup-btn', function(e){

        e.preventDefault();

        var videoUrl = $(this).attr('data-video');

        $.magnificPopup.open({
            items: {
                src: videoUrl
            },
            type: 'iframe'
        });
    });
  });
  }

  initPatientGallery() {
    const galleries = document.querySelectorAll("[data-patient-gallery]");
    if (!galleries.length || typeof jQuery === "undefined" || typeof jQuery.fn.magnificPopup === "undefined") {
      return;
    }

    const buildThumbs = (mfp) => {
      jQuery(mfp.wrap).find(".mfp-patient-thumbs").remove();

      const galleryEl = mfp.ev && mfp.ev.get ? mfp.ev.get(0) : null;
      if (!galleryEl) {
        return;
      }

      const links = galleryEl.querySelectorAll("a.patient-gallery-item");
      if (!links.length) {
        return;
      }

      const thumbs = document.createElement("div");
      thumbs.className = "mfp-patient-thumbs mfp-prevent-close";

      const track = document.createElement("div");
      track.className = "mfp-patient-thumbs__track mfp-prevent-close";

      links.forEach((link, index) => {
        const button = document.createElement("button");
        button.type = "button";
        button.className = "mfp-patient-thumbs__item mfp-prevent-close";
        button.setAttribute("data-index", String(index));
        button.setAttribute("aria-label", "View photo " + (index + 1));

        const img = document.createElement("img");
        const thumbImg = link.querySelector("img");
        img.className = "mfp-prevent-close";
        img.src = link.getAttribute("data-thumb") || (thumbImg ? thumbImg.src : "");
        img.alt = "";
        button.appendChild(img);
        track.appendChild(button);
      });

      thumbs.appendChild(track);
      mfp.wrap.append(thumbs);

      jQuery(thumbs).on("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        const item = event.target.closest(".mfp-patient-thumbs__item");
        if (!item) {
          return;
        }

        const index = parseInt(item.getAttribute("data-index"), 10);
        const instance = jQuery.magnificPopup.instance;
        if (!Number.isNaN(index) && instance && typeof instance.goTo === "function") {
          instance.goTo(index);
        }
      });
    };

    const updateActiveThumb = (mfp) => {
      const thumbs = jQuery(".mfp-patient-thumbs__item");
      if (!thumbs.length) {
        return;
      }

      thumbs.removeClass("is-active");
      const active = thumbs.eq(mfp.index).addClass("is-active");
      if (active.length && active[0].scrollIntoView) {
        active[0].scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest",
        });
      }
    };

    galleries.forEach((gallery) => {
      jQuery(gallery).magnificPopup({
        delegate: "a.patient-gallery-item",
        type: "image",
        tLoading: "Loading...",
        mainClass: "mfp-patient-gallery",
        closeBtnInside: false,
        closeOnBgClick: true,
        removalDelay: 160,
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1],
        },
        image: {
          titleSrc: function (item) {
            return item.el.attr("title") || "";
          },
        },
        callbacks: {
          open: function () {
            buildThumbs(this);
            updateActiveThumb(this);
          },
          change: function () {
            if (!this.wrap.find(".mfp-patient-thumbs").length) {
              buildThumbs(this);
            }
            updateActiveThumb(this);
          },
        },
      });
    });
  }

  fullScreenMenu() {
    if (typeof gsap === 'undefined') {
      console.warn('GSAP not loaded');
      return;
    }

    const fullScreenMenu = document.querySelector(".wps-full-screen-menu__wrapper");
    if (!fullScreenMenu) return;

    const menuToggleBtn = document.querySelector("#mobile-menu-trigger");
    const menuToggleBtn2 = document.querySelector("#mobile-menu-trigger1");
    const toggleButtons = [menuToggleBtn, menuToggleBtn2].filter(Boolean);
    const menuCloseBtn = fullScreenMenu.querySelector(".close-btn");
    const menuCollapseLinks = fullScreenMenu.querySelectorAll(".collape-menu");
    const fadeInContainers = fullScreenMenu.querySelectorAll(".fade-in-container");
    const parentMenu = fullScreenMenu.querySelectorAll(".menu-item-has-children > a");
    const openLabel = "Open menu";
    let lastFocusedToggle = null;

    const getFocusable = () => Array.from(
      fullScreenMenu.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => {
      if (el.hasAttribute("disabled") || el.getAttribute("aria-hidden") === "true") {
        return false;
      }
      const hiddenAncestor = el.closest('[aria-hidden="true"]');
      return !hiddenAncestor;
    });

    const setExpandedState = (expanded) => {
      toggleButtons.forEach((btn) => {
        btn.setAttribute("aria-expanded", expanded ? "true" : "false");
        btn.setAttribute("aria-label", openLabel);
      });
      fullScreenMenu.setAttribute("aria-hidden", expanded ? "false" : "true");
      if (expanded) {
        fullScreenMenu.removeAttribute("inert");
      } else {
        fullScreenMenu.setAttribute("inert", "");
      }
    };

    const fullScreenMenuOpenTl = gsap.timeline({ paused: true });
    const fullScreenMenuCloseTl = gsap.timeline({ paused: true });

    gsap.set(fullScreenMenu, { autoAlpha: 1 });

    fullScreenMenuOpenTl
      .fromTo(fullScreenMenu, { xPercent: 100 }, { xPercent: 0, duration: 0.6 })
      .fromTo(fadeInContainers, { opacity: 0, x: 20 }, { opacity: 1, x: 0, duration: 0.3, stagger: 0.1 }, ">5%");

    fullScreenMenuCloseTl
      .to(fadeInContainers, { opacity: 0, x: 20, duration: 0.3, stagger: 0.1 })
      .to(fullScreenMenu, { xPercent: 100, duration: 0.6, ease: "none" }, "<25%");

    const setSubmenuExpanded = (link, expanded) => {
      link.classList.toggle("rotate", expanded);
      link.classList.toggle("active", expanded);
      link.setAttribute("aria-expanded", expanded ? "true" : "false");
      const submenu = link.nextElementSibling;
      if (submenu) {
        submenu.style.maxHeight = expanded ? submenu.scrollHeight + 200 + "px" : null;
        submenu.setAttribute("aria-hidden", expanded ? "false" : "true");
      }
    };

    const handleCollapse = (curr) => {
      parentMenu.forEach((menu) => {
        if (curr === menu && menu.classList.contains("active")) return;
        setSubmenuExpanded(menu, false);
      });
    };

    const handleOpen = (event) => {
      if (fullScreenMenu.classList.contains("active")) return;
      lastFocusedToggle = event && event.currentTarget ? event.currentTarget : document.activeElement;
      fullScreenMenu.classList.add("active");
      document.body.classList.add("add-bg-color");
      document.body.style.position = "fixed";
      setExpandedState(true);
      fullScreenMenuOpenTl.restart();
      if (menuCloseBtn) {
        menuCloseBtn.focus();
      }
    };

    const handleClose = () => {
      if (!fullScreenMenu.classList.contains("active")) return;
      fullScreenMenu.classList.remove("active");
      document.body.classList.remove("add-bg-color");
      handleCollapse();
      document.body.style.position = "";
      setExpandedState(false);
      fullScreenMenuCloseTl.restart();
      if (lastFocusedToggle && typeof lastFocusedToggle.focus === "function") {
        lastFocusedToggle.focus();
      }
    };

    parentMenu.forEach((menu, index) => {
      const submenu = menu.nextElementSibling;
      if (submenu) {
        const submenuId = submenu.id || `fullscreen-submenu-${index}`;
        submenu.id = submenuId;
        submenu.setAttribute("aria-hidden", "true");
        menu.setAttribute("aria-controls", submenuId);
        menu.setAttribute("aria-expanded", "false");
        menu.setAttribute("aria-haspopup", "true");
      }

      menu.addEventListener("click", (e) => {
        e.preventDefault();
        const isOpen = menu.classList.contains("active");
        setSubmenuExpanded(menu, !isOpen);
      });

      menu.addEventListener("keydown", (e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          menu.click();
        }
      });
    });

    toggleButtons.forEach((btn) => {
      btn.addEventListener("click", handleOpen);
    });
    if (menuCloseBtn) menuCloseBtn.addEventListener("click", handleClose);

    menuCollapseLinks.forEach((link) => link.addEventListener("click", handleClose));

    fullScreenMenu.addEventListener("click", (e) => {
      if (e.target === fullScreenMenu) handleClose();
    });

    fullScreenMenu.addEventListener("keydown", (e) => {
      if (!fullScreenMenu.classList.contains("active") || e.key !== "Tab") return;
      const focusable = getFocusable();
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    window.addEventListener("keydown", (e) => {
      if (e.key === "Escape") handleClose();
    });
  }

}

new WPSDentalTheme();
